import type { TaskViewModel } from '@trinnvis/dabih-api-client';
import type { OrganizationState } from '../../types';
import { createSelector } from '@reduxjs/toolkit';
import { tasksNotDeleted } from './tasks-not-deleted';
import { currentPageId } from '../path';
import { getOrganization } from '../organization/getOrganization';

export function _isPageTask(task: TaskViewModel, pageId: number, organization: OrganizationState): boolean {
  if (!task || !pageId || !organization) {
    return false;
  }
  const assignedFunctionPages = organization.functionsById[task.functionUuid].pages;
  const assignedToCommon = organization.functionsById[task.functionUuid].type === 'COMMON';
  let hasResponsibleFunction = false;
  let responsibleFunctionPages: number[] = [];
  if (task.responsibleFunctionUuid) {
    hasResponsibleFunction = true;
    const responsibleFunction = organization.functionsById[task.responsibleFunctionUuid];
    if (responsibleFunction) {
      responsibleFunctionPages = responsibleFunction.pages;
    }
  }
  return (
    (assignedFunctionPages.includes(pageId) && !assignedToCommon) ||
    (assignedToCommon && !hasResponsibleFunction && pageId === 357) ||
    responsibleFunctionPages.includes(pageId) ||
    (task.pages !== undefined && task.pages.includes(pageId))
  );
}

export const tasksForCurrentPage = createSelector(
  tasksNotDeleted,
  currentPageId,
  getOrganization,
  (tasks, pageId, organization): TaskViewModel[] => {
    if (organization === undefined || pageId === undefined) {
      return [];
    }
    return tasks
      .filter(function (task) {
        return _isPageTask(task, pageId, organization) && !task.locked;
      })
      .sort(function (a, b) {
        if (!a.name || !b.name) {
          return 0;
        }
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
      });
  },
);
